import React, { useState, useEffect, useRef } from 'react';
import { EntityService } from "../service/EntityService";
import { LanguageService } from "../service/LanguageService";
import classNames from 'classnames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { AuthorizationService } from '../service/AuthorizationService';
import './Crud.scss'
import * as _ from 'lodash';
import { ProgressBar } from 'primereact/progressbar';
import { v4 as uuidv4 } from 'uuid';
import { Paginator } from 'primereact/paginator';

export function EntityList(props) {

    let emptyItem = {
        id: uuidv4()
    };

    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [hasAccess, setHasAccess] = useState(false);
    const [loading, setLoading] = useState(true);
    const [entity, setEntity] = useState(null);
    const toast = useRef(null);
    const entityService = new EntityService(props.entity, props.module);
    const authorizationService = new AuthorizationService(props.module);
    const languageService = new LanguageService(props.module);
    
    const [search, setSearch] = useState(props.filters ? props.filters.join(",") : '');
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [first, setFirst] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const updateList = async () => {
        const data = await entityService.list(first, rowsPerPage, search, sortField, sortOrder);
        setItems(data.items);
        setEntity(data._entity);
        setTotalRecords(data.totalRecords)
    }

    const onPageChange = async (pageEvent) => {
        setFirst(pageEvent.first);
        setRowsPerPage(pageEvent.rows);
        const data = await entityService.list(pageEvent.first, pageEvent.rows, search, sortField, sortOrder);
        setItems(data.items);
        setTotalRecords(data.totalRecords)
    }

    const doSearch = async (reset) => {
        const data = await entityService.list(first, rowsPerPage, reset ? null : globalFilter, sortField, sortOrder);
        setSearch(globalFilter);
        setItems(data.items);
        setTotalRecords(data.totalRecords)
    }

    const onSort = async (sortEvent) => {
        setSortField(sortEvent.sortField);
        setSortOrder(sortEvent.sortOrder);
        const data = await entityService.list(first, rowsPerPage, search, sortEvent.sortField, sortEvent.sortOrder);
        setItems(data.items);
        setTotalRecords(data.totalRecords)
    }

    useEffect(() => {
        try {
            const _hasAccess = props.permission ? authorizationService.hasPermission(props.permission) : true;
            setHasAccess(_hasAccess);
            if(_hasAccess){
                async function fetchData() {
                    if(props.items){
                        setItems(props.items);
                        setTotalRecords(props.items.length);
                    }
                    else {
                        await updateList();
                    }
                    
                    setLoading(false); 
                }        
                fetchData();
                
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.toString(), sticky: true });
        }
        
    }, []);

    const actionBodyTemplate = (rowData) => {
        const { onRowEdit } = props;
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => onRowEdit(rowData)} />
            </React.Fragment>
        );
    }

    const header = (
        <div className="table-header">
            <h5 className="p-m-0">{props.title[languageService.getLanguage()]}</h5>
            { props.globalSearch && <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => {setGlobalFilter(e.target.value); if(e.target.value === "") doSearch(true);}} placeholder={{"pt-BR": "Buscar...", "en-US": "Search..."}[languageService.getLanguage()]} onKeyDown={(e) => { if (e.key === 'Enter') { doSearch()}}}/>
            </span>}
        </div>
    );

    if(hasAccess){

        return (
            <div className="datatable-crud-demo">
                <Toast ref={toast} />
                <div className="card">
                    { loading && <ProgressBar mode="indeterminate"/> }

                    { !loading &&
                    <>
                    <DataTable value={items}
                        dataKey="id"
                        header={header}
                        autoLayout={(props.hasOwnProperty("autoLayout") ? props.autoLayout : true)}
                        onSort={onSort}
                        sortField={sortField} 
                        sortOrder={sortOrder}
                        style={{width: '100%'}}
                        scrollable={true}
                        >
                        { (props.columns || []).map(column => 
                            <Column 
                                key={`column_${column}`} 
                                header={entityService.getAttributeLabel(entity, column)} 
                                body={(data) => entityService.getAttributeFormatedValue(entity, column, data)}
                                ></Column>
                        )}
                        
                        <Column style={{width: '150px'}} body={actionBodyTemplate}></Column>
                    </DataTable>
                    { (props.hasOwnProperty("pagination") ? props.pagination : true) &&
                        <Paginator first={first} rows={rowsPerPage} totalRecords={totalRecords} rowsPerPageOptions={[5, 10, 25, 50, 100]} onPageChange={onPageChange}></Paginator>
                    }
                    </>
                    }
                </div>
            </div>
        );
    }
    else {
        return (
            <div className="datatable-crud-demo">
                <div className="card">
                    <b>Permission Denied</b>
                </div>
            </div>
        );
    }
}